import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import { FilterSelect } from './ActivationFilterSelect';

export default withStyles(styles)(FilterSelect);
